import React from 'react';
import {Grid} from '@mui/material';
import PageWrapper from '../utils/PageWrapper';
import Supervisor from '../contactPersons/Supervisor';
import {groupAccountCompanyDataSubSites, routeAccount} from '../../config/routeItems';
import SubpageNavigation from '../ui/SubpageNavigation';
import CompanyContactsList from '../companyContacts/CompanyContactsList';
import ChangeDataPanel from "../contactPersons/ChangeDataPanel";

function AccountCompanyContacts() {
    return (
        <PageWrapper siteTitle={'customerportal.account.contacts'} backRoute={routeAccount}>
            <Grid container
                  columnSpacing={5}
                  rowSpacing={2.5}
            >
                <Grid item
                      xs={12}
                      lg={8}
                >
                    <SubpageNavigation items={groupAccountCompanyDataSubSites} />
                    <CompanyContactsList />
                </Grid>
                <Grid item
                      xs={12}
                      lg={4}
                      sx={{
                          position: 'relative',
                      }}
                >
                    <Supervisor/>
                    <ChangeDataPanel />
                </Grid>
            </Grid>
        </PageWrapper>
    );
}

export default AccountCompanyContacts;
